import React from 'react';
import { PackageManager } from './AdminPRPackages';

export default function AdminGuestPackages() {
  return <PackageManager type="guest_post" typeLabel="Guest Post" />;
}
